import { render, staticRenderFns } from "./TipoComboPizza.vue?vue&type=template&id=03cd214a&scoped=true&"
import script from "./TipoComboPizza.vue?vue&type=script&lang=js&"
export * from "./TipoComboPizza.vue?vue&type=script&lang=js&"
import style0 from "./TipoComboPizza.vue?vue&type=style&index=0&id=03cd214a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cd214a",
  null
  
)

export default component.exports